import type { FaireProductEntity } from "../../entity_types/product";

export const p_hhrqrzfckf: FaireProductEntity = {
  token: "p_hhrqrzfckf",
  type: "product",
  name: "Women's Holiday Ribbon Bow Casual Socks",
  brandToken: "b_7didlift8g",
  brandName: "Tiepology",
  imageUrl:
    "https://cdn.faire.com/fastly/9c1d68cbf995611b30341861fb702516d516b15a7b2df0387e0de2a85c112de7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b9a58680c6207282c91e55cfdabdbb9fa22d4b86f656a5ca34338efaf4834120.jpeg",
    "https://cdn.faire.com/fastly/035dccd974f12e2a071735152df62f3f88fdb60488a52470b3cdb5a5fb4dca74.jpeg",
    "https://cdn.faire.com/fastly/a70d9d8b2be2b973fdf9f9b65a1887b20dac05d44b9ec91a086706bf55f97337.jpeg",
    "https://cdn.faire.com/fastly/848fa971f0c985f5111849f1190f8a61cc7851ca1aed80f7c77fadfd0c8eab44.jpeg",
    "https://cdn.faire.com/fastly/709ff9e5f6605d52042bf7e4f41f35f35bd32c9bd80e4d7ae18926e9a1597bc4.jpeg",
    "https://cdn.faire.com/fastly/bf6f32e58076deacc24a21aebcf04b8040599f8df8e08e87a00d27e98bd95b98.jpeg",
    "https://cdn.faire.com/fastly/42651c8704c99f5fb0d95d0012687e6c62277ba7a1c3fc8833bb867963e2b9f0.jpeg",
    "https://cdn.faire.com/fastly/c7e2cb5d814ef2d3bb84c16f715da328e8ab6f8d82d46c85cdf6aea19db1bd97.jpeg",
    "https://cdn.faire.com/fastly/e1515408b25bee7a9ab1bd3825d94bc8740b8d3c774b19e62e58789d4a996ee9.jpeg",
    "https://cdn.faire.com/fastly/a4deebe23a4350e313322d45f3aa9af7a4cb40be96c396c30970ab0a833cdcfe.jpeg",
    "https://cdn.faire.com/fastly/36e3441cd2a2dbb205b3fa8931d54d750617b75981cd3f091a492ed495aefc83.jpeg",
  ],
  priceDollars: 3.85,
  description:
    "• Adult Size\n• 80% Cotton, 15% Spandex, 5% Polyester\n• Machine Wash\n\nStay festive and comfortable with our Women's Holiday Ribbon Bow Casual Socks. Our socks feature a glitter ribbon on the back for a touch of holiday sparkle. With a focus on comfort, these socks are perfect for any holiday occasion.",
  tags: [],
  msrpDollars: 7.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:25.504Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
